import React, { KeyboardEvent, useEffect, useState } from "react"
import { Box, Button, TextField } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Layout } from "src/components/layout"
import { useAuth } from "src/providers/LoginProvider"
import { Tag, TagService } from "src/openapi"
import { ShowToast } from "../../states/showToast"
import { ShowProgress } from "../../states/showProgress"
import { useRecoilState } from "recoil"
import { TagTable } from "./TagTable"
import { SIDE_MENU, SNACKBAR_TYPES } from "src/modules/const"
import BreadCrumb from "src/components/atom/BreadCrumb"
import { useNavigate, useParams } from "react-router"
import "./index.scss"
import { Top } from "../top"

export const TagList = () => {
  const { t } = useTranslation("translation", { keyPrefix: "tag" })

  const [list, setList] = useState<Tag[]>([])

  const { companyId } = useParams()

  const { user } = useAuth()

  const [, setShowToast] = useRecoilState(ShowToast)
  const [, setShowProgress] = useRecoilState(ShowProgress)

  const [reload, setReload] = useState<boolean>(false)
  const [keyword, setKeyword] = useState<string>("")
  const [tmpKeyword, setTmpKeyword] = useState<string>("")

  const navigate = useNavigate()

  const handleGetTagList = () => {
    if (user == null) {
      return
    }
    setShowProgress(true)
    TagService.listTags(user.token, Number(companyId), undefined, undefined, keyword)
      .then((res) => {
        setShowProgress(false)
        setList(res)
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({
          show: true,
          text: t("failed_get_tag_list"),
          type: SNACKBAR_TYPES.ERROR,
        })
      })
  }

  useEffect(() => {
    if (user == null) {
      return
    }
    handleGetTagList()
  }, [user, keyword])

  useEffect(() => {
    if (user == null) {
      return
    }
    if (!reload) {
      return
    }

    setReload(false)
    handleGetTagList()
  }, [user, reload])

  const handleKeyboardEvent = (e: KeyboardEvent<HTMLImageElement>) => {
    if (e.key == "Enter") {
      setShowProgress(keyword != tmpKeyword)
      setKeyword(tmpKeyword)
    }
  }
  if (!user) {
    return <Top />
  }

  return (
    <Layout menu={SIDE_MENU.TAG_LIST}>
      <Box className="flex-container">
        <Box className="header">
          <BreadCrumb
            paths={[
              {
                name: t("list_title"),
                link: "",
              },
            ]}
          />
          <Box className="tag-filter-bar">
            <Box className="filter-section">
              <TextField
                value={tmpKeyword}
                placeholder={t("please_input")}
                sx={{
                  width: "380px",
                  height: "38px",
                  mb: "10px",
                  "& .MuiInputBase-input": {
                    height: "38px",
                    padding: "0px 10px",
                    fontFamily: "Zen Kaku Gothic New !important",
                  },
                  fontFamily: "Zen Kaku Gothic New !important",
                }}
                onChange={(event) => {
                  setTmpKeyword(event.target.value)
                }}
                onKeyUp={handleKeyboardEvent}
              />
              <Button
                className="search-button"
                onClick={() => {
                  setKeyword(tmpKeyword)
                }}
              >
                {t("btn_search")}
              </Button>
              <Button
                className="clear-button"
                onClick={() => {
                  setTmpKeyword("")
                  setKeyword("")
                }}
              >
                {t("btn_clear")}
              </Button>
            </Box>

            <Box className="pagination-section">
              <Button
                className="register-button"
                onClick={() => navigate(`/company/${companyId}/tag/register`)}
              >
                {t("btn_new_tag")}
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className="content" sx={{ width: "40%" }}>
          <TagTable data={list} companyId={Number(companyId)}></TagTable>
        </Box>
      </Box>
    </Layout>
  )
}
